import { APICore } from "./apiCore";

const api = new APICore();

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const STORY_ENDPOINT = 'api/v1/admin/collection_configs';

function fetchCollectionConfigs() {
  return api.get(`${baseUrl}/${STORY_ENDPOINT}`, {});
}

function createCollectionConfig(data: any) {
  return api.create(`${baseUrl}/${STORY_ENDPOINT}`, data);
}

function updateCollectionConfig(id: string, data: any) {
  return api.update(`${baseUrl}/${STORY_ENDPOINT}/${id}`, data);
}

function deleteCollectionConfig(id: string) {
  return api.delete(`${baseUrl}/${STORY_ENDPOINT}/${id}`);
}

export {
  fetchCollectionConfigs,
  createCollectionConfig,
  updateCollectionConfig,
  deleteCollectionConfig
}